import { Table, TableBody } from "@mui/material";
import { Lock as PortalIcon } from "@mui/icons-material";
import type { ContactEmails } from "../types";
import { SectionCard } from "../components/SectionCard";
import { FieldRow } from "../components/FieldRow";
import { formatEmailList } from "../utils/format";

type Props = {
  contactEmails: ContactEmails;
  isKws: boolean;
};

export function PortalAccessSection({ contactEmails, isKws }: Props) {
  return (
    <SectionCard icon={<PortalIcon fontSize="small" />} title="Portal Access">
      <Table size="small">
        <TableBody>
          <FieldRow
            label="Vendor Invoice Portal Access Email"
            value={formatEmailList(contactEmails.vendor_invoice_portal_access_email)}
          />
          {isKws && (
            <FieldRow
              label="TARs Production Process Access Email"
              value={formatEmailList(
                contactEmails.tars_production_process_management_access_email,
              )}
            />
          )}
        </TableBody>
      </Table>
    </SectionCard>
  );
}

export default PortalAccessSection;
